import { Heading, Text } from "@/src/components/ui/Typography";

import type { UseCaseItem } from "./UseCasesShowcase";

interface UseCaseDetailProps {
  categoryLabel: string;
  item: UseCaseItem;
}

export function UseCaseDetail({ categoryLabel, item }: UseCaseDetailProps) {
  return (
    <div className="rounded-(--radius-lg) border border-neutral-200 bg-neutral-50 p-6 md:p-8">
      <Text size="labelSM" className="uppercase tracking-widest text-brand">
        {categoryLabel}
      </Text>

      <Heading as="h3" size="headingLG" className="mt-2 text-neutral-700">
        {item.title}
      </Heading>

      <div className="mt-6 flex flex-col gap-5">
        <div>
          <Text size="labelSM" className="uppercase tracking-widest text-neutral-500">
            Situation
          </Text>
          <Text size="bodySM" className="mt-2 text-neutral-600">
            {item.situation}
          </Text>
        </div>

        <div>
          <Text size="labelSM" className="uppercase tracking-widest text-neutral-500">
            Solution
          </Text>
          <Text size="bodySM" className="mt-2 text-neutral-600">
            {item.solution}
          </Text>
        </div>

        <div className="rounded-(--radius-sm) bg-white p-4">
          <Text size="labelSM" className="uppercase tracking-widest text-brand">
            Outcome
          </Text>
          <Text size="bodySMMedium" className="mt-2 text-neutral-700">
            {item.outcome}
          </Text>
        </div>
      </div>
    </div>
  );
}
